const MFA_CONTEXT_KEY = "facility360_mfa_context";

export type MfaContext = {
  nextPath: string;
  method: "email" | "app" | "sms" | "unknown";
  /** Short-lived MFA challenge id returned by Frappe step 1. Must be echoed back with the OTP. */
  tmpId?: string;
};

export function saveMfaContext(context: MfaContext) {
  window.sessionStorage.setItem(MFA_CONTEXT_KEY, JSON.stringify(context));
}

export function readMfaContext(): MfaContext | null {
  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(MFA_CONTEXT_KEY) ?? "null") as Partial<MfaContext> | null;
    if (!parsed || typeof parsed.nextPath !== "string") return null;
    return {
      nextPath: parsed.nextPath,
      method: parsed.method === "email" || parsed.method === "app" || parsed.method === "sms" ? parsed.method : "unknown",
      tmpId: typeof parsed.tmpId === "string" && parsed.tmpId ? parsed.tmpId : undefined,
    };
  } catch {
    return null;
  }
}

export function clearMfaContext() {
  window.sessionStorage.removeItem(MFA_CONTEXT_KEY);
}
